"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var AnchorStyled = _styledComponents.default.a.withConfig({
  displayName: "Anchor__AnchorStyled",
  componentId: "sc-15sqto0-0"
})(["", ""], function (_ref) {
  var kind = _ref.kind,
    theme = _ref.theme;
  var textDecoration = 'none';
  var linkColor;
  var linkHoverColor;
  switch (kind) {
    case 'primary':
      linkColor = theme.color.primary;
      linkHoverColor = theme.color.primaryDarkest;
      break;
    case 'light':
      linkColor = theme.color.white;
      linkHoverColor = theme.color.ash;
      textDecoration = 'underline';
      break;
    default:
      linkColor = theme.color.link;
      linkHoverColor = theme.color.linkHover;
  }
  return "\n      ".concat(theme.typeScale.default, "\n\n      color: ").concat(linkColor, ";\n      cursor: pointer;\n      font-family: ").concat(theme.font.primaryRegular, ";\n      text-decoration: ").concat(textDecoration, ";\n      font-weight: ").concat(theme.anchor.fontWeight, ";\n\n      &:active,\n      &:focus {\n        outline: none;\n      }\n\n      &:hover {\n        @media (min-width: ").concat(theme.breakpoint.lg.min, ") {\n          color: ").concat(linkHoverColor, ";\n          text-decoration: underline;\n        }\n      }\n\n      h1 &,\n      h2 &,\n      h3 &,\n      h4 &,\n      h5 &,\n      h6 &,\n      p & {\n        font-family: inherit;\n        font-size: inherit;\n        font-style: inherit;\n        font-weight: inherit;\n      }\n\n      em {\n        font-style: italic;\n      }\n\n      strong {\n        font-weight: bold;\n      }\n    ");
});
var _default = exports.default = AnchorStyled;